<template>
  <div>
    <h2>Add Event</h2>
    <v-select
      :items="eventTypes"
      v-model="eventtypeid"
      label="Event type:"
      item-text="name"
      item-value="id"
      prepend-icon="reorder"
      autofocus
      required
      outline
    />
    <DateDropdown label="Event date" v-model="customdate" />
    <v-btn @click="createEvent"> <v-icon>save</v-icon>Save </v-btn>
  </div>
</template>

<script>
import DateDropdown from "@/components/date/DateDropdown";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Event",
  components: { DateDropdown },
  data() {
    return {
      eventTypes: [],
      eventtypeid: null,
      customdate: new Date().toISOString().substr(0, 10),
      modal: false
    };
  },
  methods: {
    async fetchEventTypes() {
      const response = await nbmlaw.get(
        `/cors/admin/file/files/${this.$route.params.id}/eventTypes`
      );
      // console.log(response.data);
      this.eventTypes = response.data;
    },
    createEvent() {
      this.$emit("create", {
        id: Number(this.$route.params.id),
        eventtypeid: this.eventtypeid,
        customdate: this.customdate
      });
    }
  },
  watch: {
    eventTypes() {
      if (this.eventTypes && this.eventTypes.length) {
        this.eventtypeid = this.eventTypes[0].id;
      }
    }
  },
  created() {
    this.fetchEventTypes();
  }
};
</script>
